import {memo, useCallback, useMemo} from "react";
import FooterMenu, {FooterListItem} from "./Sidebar/FooterMenu";
import {useTranslation} from "react-i18next";

interface FilterDropdownProps {
    name: string,
    list: FooterListItem[],
    selected?: number,
    onChange: (s: string | number) => void,
    className?: string,
    searchable?: boolean,
    withAllElement?: boolean,
    filterClassName?: string
}

const StatusDropdown = ({
                            onChange,
                            selected,
                            list,
                            name,
                            className,
                            filterClassName,
                            searchable = true,
                            withAllElement = true
                        }: FilterDropdownProps) => {
    const {t} = useTranslation();
    const selectedName = useCallback(() => {
        if (selected) {
            return list.find(i => i.id === selected)?.name ?? '';
        }
        return withAllElement ? `: ${t('All')}` : '';
    }, [list, selected]);

    const dropdownUI = useMemo(() => {
        return <FooterMenu
            buttonClassName={`px-4 py-3 text-white bg-black ${className ?? ''}`}
            selected={`${name} ${selectedName()}`}
            onClick={onChange}
            list={list.map((i) => {
                return {id: i.id, name: i.name.toString().length > 0 ? i.name : (i.code ?? '')};
            })}
            className={`px-2 rounded-[0.5rem] ${filterClassName ?? ''}`}
            searchable={searchable}
            withAllElement={withAllElement}
        />;
    }, [list, onChange, name, selectedName, className, searchable])

    return <>{dropdownUI}</>
}

export default memo(StatusDropdown);
